exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */preview-summary-button button{position:fixed;bottom:0;z-index:100}[dir=ltr] preview-summary-button button,[dir=rtl] preview-summary-button button{left:0;right:0}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/preview-summary-button/preview-summary-button.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/preview-summary-button/preview-summary-button.component.scss
// module chunks = 0